module.exports = __webpack_public_path__ + "img/badge_0feuille@2x.c7a8cee4.png";